/* @jsx h */
import { h, Fragment } from "preact";
import Sublist from "../Sublist";
import { useChecklistContext } from "../../context";
import { useLayoutEffect, useRef, useState, useEffect } from "preact/hooks";
import { useMediaQuery } from "react-responsive";
import { getSublistContainerHeight } from "../../helpers";
import { MEDIA_QUERY_FOR_DESKTOP_VIEW } from "../../constants";
import CTA from "../CTA";
import Autosave from "../Autosave";
import "./checklist.scss";

/*
 * This component is responsible for rendering both "designed-for-digital" and
 * "designed-to-be-printable" checklists. Whether printable is determined by the
 * checklist's parent's css class.
 *
 * In order to maintain CSS Masonry grid in desktop, the sublists wrapper container needs
 * to have a fixed height largest that tallest column. Since the list is both
 * dynamic and interactive, we need to measure column heights when:
 *          - items are first loaded in
 *          - items are checked/unchecked (increased padding for checked items),
 *          - sublists are opened/closed
 *          - the window is resized (item text can wrap to multiple lines, increasing height)
 */
function Checklist() {
    const { userToken, sublists, title, subtitle, userCheckedItems, userClosedSublists, loaded } =
        useChecklistContext();
    const createSublists = (sublists) => sublists.map((sublist) => <Sublist key={sublist.id} sublist={sublist} />);
    const isDesktop = useMediaQuery({ query: MEDIA_QUERY_FOR_DESKTOP_VIEW });
    const sublistRef = useRef();
    const [desktopSublistContainerHeight, setContainerHeight] = useState("100%");

    const updateContainerHeight = () => {
        if (isDesktop) {
            const sublistHTMLArray = [...sublistRef.current.childNodes];
            setContainerHeight(getSublistContainerHeight(sublistHTMLArray));
        }
    };

    useLayoutEffect(() => {
        updateContainerHeight();
    }, [userCheckedItems, userClosedSublists, sublists]);

    useEffect(() => {
        window.addEventListener("resize", updateContainerHeight);
        return () => window.removeEventListener("resize", updateContainerHeight);
    });

    return (
        <div className={"checklist"}>
            <h1 className="checklist-title">{title}</h1>
            <p className="checklist-subtitle">{subtitle}</p>
            <Fragment>
                {/* min height to be size of button */}
                {loaded && (
                    <div className="checklist-save-menu" style={{ minHeight: "2.5rem" }}>
                        {userToken ? <Autosave /> : <CTA />}
                    </div>
                )}
                <div
                    className="sublists"
                    ref={sublistRef}
                    style={{ height: isDesktop ? desktopSublistContainerHeight : "100%" }}
                >
                    {createSublists(sublists)}
                </div>
            </Fragment>
            <p className="copyright">© Inter IKEA Systems B.V. 2022</p>
            {/* for some reason, image is cut off in safari but div with background image works.
                 todo- figure out why this is?
             */}
            <div
                className="pdf-logo"
                style={{
                    backgroundImage: `url(https://${window.location.hostname}/us/en/static/ikea-logo.f7d9229f806b59ec64cb.svg)`
                }}
            />
        </div>
    );
}

export default Checklist;
